import { DocumentServicesObject } from '@wix/document-services-types';
import { AppExposure } from '@wix/editor-platform-host-integration-apis';
import { PlatformContext } from '../../../types/platformApi';
import { buildAppExposures, GroupType } from './utils';

// ─── Public service ────────────────────────────────────────────────────────
/**
 * Private service. Owns reading EditorExposure data off the ClientSpecMap
 * and shaping it into the AppExposure domain type.
 *
 * Three filtered readers, one per editor surface. All shaping/selection logic
 * lives in ./utils.
 */
export const ExposureService = {
  /**
   * Returns each installed app's EditorExposure groups of type COMPONENTS,
   * shaped as AppExposure[]. Per app, the EditorExposure instance that applies
   * to the current editor is selected (see buildAppExposures). Apps without an
   * applicable instance or without any COMPONENTS-typed group are omitted.
   */
  getComponentGroups: (
    documentServices: DocumentServicesObject,
    context: PlatformContext,
  ): Promise<AppExposure[]> =>
    buildAppExposures(documentServices, GroupType.COMPONENTS, context),

  // TODO: implement once Section Panel adapter lands.
  getSectionGroups: (
    _documentServices: DocumentServicesObject,
    _context: PlatformContext,
  ): Promise<AppExposure[]> => Promise.resolve([]),

  // TODO: implement once Add Page adapter lands.
  getPageGroups: (
    _documentServices: DocumentServicesObject,
    _context: PlatformContext,
  ): Promise<AppExposure[]> => Promise.resolve([]),
};
